<template>
  <div>
    <el-table :data="list" height="700">
      <!-- <el-table-column label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime | moment }}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="tenantName" label="租户"></el-table-column>
      <el-table-column label="转账时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
          <!-- <span>{{ scope.row.businessTime | moment }}</span> -->
        </template>
      </el-table-column>
      <!-- <el-table-column prop="fromUserId" label="转出账号"></el-table-column> -->
      <el-table-column prop="userId" label="转入账号"></el-table-column>
      <el-table-column prop="type" label="钱包类型">
        <template slot-scope="scope">
          <span>{{ typeList[scope.row.type] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coin" label="币种"></el-table-column>
      <el-table-column
        prop="availableChange"
        label="转账金额"
      ></el-table-column>
      <el-table-column prop="openUserId" label="操作人"></el-table-column>
      <!-- <el-table-column prop="availableChangeBefore" label="转入前金额"></el-table-column> -->
      <!-- <el-table-column
        prop="availableAfterChange"
        label="转入后金额"
      ></el-table-column> -->
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Pagination from "components/pagination";
import { TYPE } from "../../constants";

export default {
  name: "transferInnerMockList",
  data() {
    return {
      typeList: {
        OTC: "资金账户",
        CONTRACT: "合约账户",
        SUPER: "超级合约钱包",
        SPOT: "现货账户",
        FINANCIAL: "理财账户",
      },
    };
  },
  computed: {
    ...mapState("transferInnerMock", ["totalCount", "pagination"]),
    ...mapGetters("transferInnerMock", ["list"]),
  },
  components: {
    Pagination,
  },

  methods: {
    ...mapActions("transferInnerMock", ["remove"]),
    ...mapMutations("transferInnerMock", ["setDetail"]),
    handleCurrentChange(pagination) {
      this.$emit("refresh", pagination);
    },
    viewDetail(item) {
      this.setDetail(item);
    },
    removeItem(row) {
      this.$confirm("确认要删除么？", "提示", {
        type: "warning",
      }).then(() => {
        this.remove(row.id).then(() => {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
          this.$emit("refresh", { page: 1 });
        });
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
